// Generated by ts-to-zod
import { z } from 'zod';
import { queueRuleActionSchema } from '../../../rules/models/queueRule.schema';
import { urlSchema } from '../../../types.schema';

export const suggestRulePayloadSchema = z.object({
  userQuery: z.string(),
  queue: urlSchema,
});

export const suggestRuleResultSchema = z.object({
  description: z.string().optional(),
  enabled: z.boolean().optional(),
  id: z.string().optional(),
  triggerCondition: z.string().optional(),
  triggerConditionSummary: z.string().optional(),
  name: z.string().optional(),
  actions: z.array(queueRuleActionSchema.partial()).optional(),
});

export const suggestRuleResponseSchema = z.object({
  results: z.array(suggestRuleResultSchema),
});
